export type { MailRibbonConfigStore } from './types/mailRibbonConfigStore';
export type { MailRibbonGroup } from './types/mailRibbonGroup';
export type { TabScalingAndLayoutConfig } from './types/tabScalingAndLayoutConfig';
export { LabelPreferenceId } from './util/labelPreferencesIds';
export { defaultConfig } from './util/defaultConfig';
